<template>
  <div class="tableCard">
    <a-row :gutter="16">
      <a-col
        class="gutter-row"
        :span="8"
        v-for="(item, index) in tableList"
        :key="'item' + index"
      >
        <div class="block" @click="moreClick(item)">
          <img
            :src="item.img"
            alt=""
            v-if="item.img && item.img !== ''"
            class="imgClass"
          />
          <img src="/static/noImg.png" alt="" class="imgClass imgNone" v-else />
        </div>
        <div class="text" @click="moreClick(item)">
          {{ item.name || item.title || '-' }}
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  props: {
    tableList: Array,
    height: {
      type: Number,
      default: () => 224
    }
  },
  data() {
    return {}
  },
  mounted() {
    
  },
  methods: {
    moreClick(val) {
      this.$emit('moreChange', val)
    }
  }
}
</script>
